import { MarketingBannerTray } from '../../../domain/marketing-banner-tray';
import { CreateMarketingBannerPageItemRequestApiModel, UpdateMarketingBannerPageItemRequestApiModel } from '@cxb/editor-stb-api';
import { mapperPipe, PlatformType, remainderMapper } from 'osn-shared';
import {
  nameLocalizedMapperDomainToApi,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
} from '../../mapping/create-tray-domain-to-api';
import { MarketingBannerPageItemApiModel } from '@cxb/editor-stb-api/model/models';
import {
  commonMapper,
  nameLocalizedMapperApiToDomain,
  scheduledDateMapperApiToDomain,
  targetingMapperApiToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { MarketingBannerTrayFormViewModel } from './marketing-banner-tray-form.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  nameLocalizedMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  nameLocalizedMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'MarketingBannerTray'

/**
 * DOMAIN -> API
 */

export const mapMarketingBannerTrayDomainModelToApiModel = (
  item: MarketingBannerTray,
  pageVersionId?: string,
  tenantId?: string
): CreateMarketingBannerPageItemRequestApiModel & UpdateMarketingBannerPageItemRequestApiModel => {
  const commonProperties = mapperPipe(item, nameLocalizedMapperDomainToApi, targetingMapperDomainToApi, scheduledDateMapperDomainToApi);

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    backgroundImage: item.backgroundImage.BIGSCREEN.en.id,
    headlineLocalized: {
      en: item.headlineLocalized.en,
      ar: item.headlineLocalized.ar,
    },
    descriptionLocalized: {
      en: item.descriptionLocalized.en,
      ar: item.descriptionLocalized.ar,
    },
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */

export const mapMarketingBannerTrayApiModelToDomainModel = (pageItem: MarketingBannerPageItemApiModel): MarketingBannerTray => {
  return remainderMapper(
    mapperPipe(pageItem, commonMapper, nameLocalizedMapperApiToDomain, targetingMapperApiToDomain, scheduledDateMapperApiToDomain),
    () => ({
      type: 'MarketingBannerTray',
      backgroundImage: {
        [PlatformType.BigScreen]: {
          en: {
            id: pageItem.backgroundImage.id,
            name: pageItem.backgroundImage.originalName,
            publicUrl: pageItem.backgroundImage.publicUrl,
          },
        },
      },
      headlineLocalized: {
        en: pageItem.headlineLocalized.en,
        ar: pageItem.headlineLocalized.ar,
      },
      descriptionLocalized: {
        en: pageItem.descriptionLocalized.en,
        ar: pageItem.descriptionLocalized.ar,
      },
    })
  );
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapMarketingBannerTrayDomainModelToViewModel = (pageItem: MarketingBannerTray): MarketingBannerTrayFormViewModel => {
  const commonProperties = mapperPipe(
    pageItem,
    commonMapper,
    nameLocalizedMapperDomainToViewModel,
    targetingMapper,
    scheduledDateMapperDomainToViewModel
  );

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.MarketingBannerTray,
    headlineLocalized: {
      en: pageItem.headlineLocalized.en,
      ar: pageItem.headlineLocalized.ar,
    },
    descriptionLocalized: {
      en: pageItem.descriptionLocalized.en,
      ar: pageItem.descriptionLocalized.ar,
    },
    backgroundImage: pageItem.backgroundImage,
  }));
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapMarketingBannerTrayViewModelToDomainModel = (vm: MarketingBannerTrayFormViewModel): MarketingBannerTray => {
  const commonProperties = mapperPipe(
    vm,
    commonMapper,
    nameLocalizedMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain
  );

  return remainderMapper(commonProperties, () => ({
    type: 'MarketingBannerTray',
    backgroundImage: vm.backgroundImage,
    headlineLocalized: vm.headlineLocalized,
    descriptionLocalized: vm.descriptionLocalized,
  }));
};
